import { observable, transaction } from 'mobx';

export default class PreviewService {
    @observable
    public isPreview = false;

    public updateElementPreviewState = (isPreview: boolean): void => {
        transaction(() => {
            this.isPreview = isPreview;
        });
    };
}
